export enum EVENT {
  INITIAL_INTERACTION = 'APP:initial_interaction',
  MUTE = 'APP::mute',
  PAUSE = 'APP::pause',
  PLAY = 'APP::play',
  VIDEO_READY = 'APP::Video:ready',
  RESET = 'APP::reset',
  PAYOUT_CLICK = 'APP::payout_click',
  SCROLLED_TO_BOTTOM = 'APP::scrolled_to_bottom',
  CATEGORY_SELECTED = 'APP::category_selected',
  HEADER_COMPONENT_LOADED = 'APP::header_component_loaded',
  FOOTER_COMPONENT_LOADED = 'APP::footer_component_loaded',
  PRODUCT_SWIPER = 'APP::product_swiper',
  SET_HEADER_OUT_FLOW = 'APP::set_header_out_flow',
  SET_FOOTER_OUT_FLOW = 'APP::set_footer_out_flow',
}

export type EventNamesBase = string | symbol;
